module.exports = __webpack_public_path__ + "img/add__card.655dc70e.png";